import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  companyFeatures: [],
  employeeFeatures: [],
}

export const mutations = {
  SET_COMPANY_FEATURES(state, companyFeatures) {
    state.companyFeatures = companyFeatures
  },
  SET_EMPLOYEE_FEATURES(state, employeeFeatures) {
    state.employeeFeatures = employeeFeatures
  },
  ADD_EMPLOYEE_FEATURE_TOGGLE(state, employeeFeatureToggle) {
    state.employeeFeatures.push(employeeFeatureToggle)
  },
  DELETE_EMPLOYEE_FEATURE_TOGGLE(state, employeeFeatureToggleUuid) {
    const index = state.employeeFeatures.findIndex(
      (el) => el.employee_feature_toggle_uuid === employeeFeatureToggleUuid
    )
    if (index !== -1) state.employeeFeatures.splice(index, 1)
  },
  EDIT_EMPLOYEE_FEATURE_TOGGLE(state, employeeFeatureToggle) {
    const index = state.employeeFeatures.findIndex(
      (el) =>
        el.employee_feature_toggle_uuid ===
        employeeFeatureToggle.employee_feature_toggle_uuid
    )
    if (index !== -1) {
      state.employeeFeatures.splice(index, 1, employeeFeatureToggle)
    }
  },
}

export const actions = {
  fetchCompanyFeatures({ commit }, payload) {
    return ApiService.fetchCompanyFeatures(payload)
      .then((res) => {
        const companyFeatures = res.data.data
        commit('SET_COMPANY_FEATURES', companyFeatures)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeeFeatures({ commit }, company_uuid) {
    return ApiService.fetchEmployeeFeatures(company_uuid)
      .then((res) => {
        const employeeFeatures = res.data.data
        commit('SET_EMPLOYEE_FEATURES', employeeFeatures)
      })
      .catch((error) => {
        throw error
      })
  },
  addEmployeeFeatureToggle({ commit }, payload) {
    return ApiService.addEmployeeFeatureToggle(payload)
      .then((res) => {
        const employeeFeatureToggle = res.data
        commit('ADD_EMPLOYEE_FEATURE_TOGGLE', employeeFeatureToggle)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeeFeatureToggle({ commit }, payload) {
    return ApiService.deleteEmployeeFeatureToggle(payload)
      .then(() => {
        commit(
          'DELETE_EMPLOYEE_FEATURE_TOGGLE',
          payload.employee_feature_toggle_uuid
        )
      })
      .catch((error) => {
        throw error
      })
  },
  editEmployeeFeatureToggle({ commit }, payload) {
    return ApiService.editEmployeeFeatureToggle(payload)
      .then((res) => {
        const employeeFeatureToggle = res.data
        commit('EDIT_EMPLOYEE_FEATURE_TOGGLE', employeeFeatureToggle)
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {}
